export const manageShopURL = (link) => {
  let urlObj = new URL(link);

  if (urlObj.host === 'www.amazon.com.au') {
    urlObj.searchParams.set('tag', 'buywisely0c-22');
  } else if (urlObj.host === 'www.ebay.com.au') {
    urlObj.searchParams.append('mkcid', '1');
    urlObj.searchParams.append('mkrid', '705-53470-19255-0');
    urlObj.searchParams.append('siteid', '15');
    urlObj.searchParams.append('campid', '5338984176');
    urlObj.searchParams.append('customid', '');
    urlObj.searchParams.append('toolid', '10001');
    urlObj.searchParams.append('mkevt', '1');
  } else if (urlObj.host === 'www.trsports.com.au') {
    urlObj = new URL('https://t.cfjump.com/86032/t/85784');
    urlObj.searchParams.append('Url', link);
  } else if (urlObj.host === 'www.kogan.com') {
    urlObj.searchParams.append(
      'ref_influencer',
      'httpswwwkogancomaumybuywisely'
    );
    urlObj.searchParams.append('ref_source', 'shop');
  } else {
    urlObj.searchParams.append('utm_source', 'buywisely');
  }
  return urlObj.toString();
};

export const validUrl = (urlString) => {
  const urlRegex =
    /^(https?:\/\/)?(([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?)/;
  if (!urlRegex.test(urlString)) {
    return;
  }
  try {
    if (!/^https?:\/\//i.test(urlString)) {
      urlString = 'https://' + urlString;
    }
    const url = new URL(urlString);
    return `${url.host.replace('www.', '')}${url.pathname}${url.search}`;
  } catch (_) {
    return;
  }
};

export const getQueryStringParam = (param) => {
  if (typeof window === 'undefined') {
    return '';
  }
  const params = new URLSearchParams(window.location.search);
  return params.get(param) || '';
};
